import { render, staticRenderFns } from "./cool.popup.vue?vue&type=template&id=d354d154&scoped=true"
import script from "./cool.popup.vue?vue&type=script&lang=js"
export * from "./cool.popup.vue?vue&type=script&lang=js"
import style0 from "./cool.popup.vue?vue&type=style&index=0&id=d354d154&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d354d154",
  null
  
)

export default component.exports